import React from 'react';

import "./scss/style.scss";
import Header from "./components/Header";
import Footer from './components/Footer';
import About from "./components/About";
import Services from "./components/Services";
import Portfolio from './components/Portfolio';
import Contact from './components/Contact';

function App() {
  return (
    <div id="home" className="padding-top-75">
      <Header />
      <div className="container">
        <main>
          <About />
          <hr className="divider" />
          <Services />
          <hr className="divider" />
          <Portfolio />
          <hr className="divider" />
          <Contact />
        </main>
        <hr className="divider" />
        <Footer />
      </div>
    </div>
  );
}

export default App;
